import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let top = '70%';

const mql = window.matchMedia('(max-width: 400px)');
if (mql.matches) {
    top = '95%';
}

const handleAnimations = (sections) => {
    sections?.forEach((section) => {
        ScrollTrigger.create({
            trigger: section,
            start: `top ${top}`,
            onEnter: () => {
                section.classList.add('animated');
            },
        });
    });
};

const elementsToBeAnimated = document.querySelectorAll('.gsap-animate');

if (elementsToBeAnimated.length) {
    handleAnimations(elementsToBeAnimated);
}

